import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'vuetify/src/styles/main.sass'

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#FC5454',
        secondary: '#D8C3A5',
        accent: '#E85A4F',
        info: '#8E8D8A',
        warning: colors.amber.base,
        error: colors.deepOrange.accent4,
        success: colors.green.accent3
      }
    }
  }
}


Vue.use(Vuetify, opts)


export default new Vuetify(opts)